import { InjectionToken, FactoryProvider, PLATFORM_ID } from "@angular/core";
import { isPlatformBrowser } from "@angular/common";

export const WINDOW = new InjectionToken<Window>('Window');

export function WINDOW_PROVIDER_FACTORY(platformId: Object): Window | Object {
    if (isPlatformBrowser(platformId)) {
        return window;
    }

    return new Object();
}

export const WINDOW_PROVIDER: FactoryProvider = {
    provide: WINDOW,
    deps: [PLATFORM_ID],
    useFactory: WINDOW_PROVIDER_FACTORY
}
